<template>
    <div style="width: auto;height: 100%;">
        <img src="../assets/img/top.jpg" style="position: absolute;z-index: -100;width: 100%;height: 175px;">

        <v-menu></v-menu>
        <div class="main-width content-height">
            <!-- <transition name="el-fade-in"> -->
            <router-view></router-view>
            <!-- </transition> -->
        </div>
        <v-footer></v-footer>
    </div>
</template>
<script>
import vMenu from "@/components/Menu.vue"
import vFooter from "@/components/Footer.vue"
export default {
    components: {
        vMenu,
        vFooter
    },
    data() {
        return {
            fxDisplay: true,
            xyDisplay: true
        }
    },
    methods: {
        goFxWeb: function() {
            window.open("http://www.fangxian.gov.cn/");
        },
        goXyWeb: function() {
            window.open("http://shiyan.hbcredit.gov.cn/");
        }
    }
}
</script>